import { Reminder } from '../types/reminders';

export const DUMMY_REMINDERS: Array<Reminder> = [
  {
    id: 1,
    client: 'Milhan Joardar Aumi',
    associate: 'John Doe',
    message: 'Hello? are you there...',
    is_read: false,
  },
  {
    id: 2,
    client: 'Alice Smith',
    associate: 'Jane Roe',
    message: 'Can we reschedule our meeting?',
    is_read: true,
  },
  {
    id: 3,
    client: 'Bob Johnson',
    associate: 'John Doe',
    message: 'I need the latest report.',
    is_read: false,
  },
  {
    id: 4,
    client: 'Charlie Brown',
    associate: 'Jane Roe',
    message: 'Thank you for your help!',
    is_read: true,
  },
  {
    id: 5,
    client: 'David Wilson',
    associate: 'John Doe',
    message: 'Please call me back.',
    is_read: false,
  },
  {
    id: 6,
    client: 'Eve Davis',
    associate: 'Jane Roe',
    message: 'The project deadline is tomorrow.',
    is_read: true,
  },
  {
    id: 7,
    client: 'Frank Miller',
    associate: 'John Doe',
    message: 'I have sent the documents.',
    is_read: false,
  },
  {
    id: 8,
    client: 'Grace Lee',
    associate: 'Jane Roe',
    message: 'Could you review my proposal?',
    is_read: true,
  },
  {
    id: 9,
    client: 'Henry Walker',
    associate: 'John Doe',
    message: 'When is the next meeting?',
    is_read: false,
  },
  {
    id: 10,
    client: 'Ivy Young',
    associate: 'Jane Roe',
    message: 'I will be out of the office next week.',
    is_read: true,
  },
  {
    id: 11,
    client: 'Jack King',
    associate: 'John Doe',
    message: 'Let’s discuss the contract details.',
    is_read: false,
  },
  {
    id: 12,
    client: 'Kate Green',
    associate: 'Jane Roe',
    message: 'Here is the updated file.',
    is_read: true,
  },
  {
    id: 13,
    client: 'Liam Harris',
    associate: 'John Doe',
    message: 'We need to finalize the budget.',
    is_read: false,
  },
  {
    id: 14,
    client: 'Mia Robinson',
    associate: 'Jane Roe',
    message: 'Can we have a quick call?',
    is_read: true,
  },
  {
    id: 15,
    client: 'Noah Clark',
    associate: 'John Doe',
    message: 'I am waiting for your response.',
    is_read: false,
  },
  {
    id: 16,
    client: 'Olivia Lewis',
    associate: 'Jane Roe',
    message: 'Please review the attached document.',
    is_read: true,
  },
  {
    id: 17,
    client: 'Paul Martinez',
    associate: 'John Doe',
    message: 'Let me know your availability.',
    is_read: false,
  },
  {
    id: 18,
    client: 'Quinn Taylor',
    associate: 'Jane Roe',
    message: 'I will send the invoice today.',
    is_read: true,
  },
  {
    id: 19,
    client: 'Rachel Anderson',
    associate: 'John Doe',
    message: 'The meeting has been postponed.',
    is_read: false,
  },
  {
    id: 20,
    client: 'Sam Moore',
    associate: 'Jane Roe',
    message: 'Do you have any updates for me?',
    is_read: true,
  },
  {
    id: 21,
    client: 'Tina Hill',
    associate: 'John Doe',
    message: 'Looking forward to our meeting.',
    is_read: false,
  },
];
